import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FileUploadAPI, GetAPI, PostAPI, PutAPI } from '../ultilies/API';
import '../css/brandForm.css';
import { ApiUrls } from '../ultilies/Variables';
import { FormAPI } from '../ultilies/FormAPI';
import { GoBack } from '../ultilies/common';

function BrandForm() {
    const { state } = useLocation(); // Contains brand data if editing
    const navigate = useNavigate();
    const isEdit = !!state;

    const [formData, setFormData] = useState({
        name: state?.name || '',
        industryId: state?.industryId || '',
        description: state?.description || '',
        brandPlayableDescription: state?.brandPlayableDescription || '',
        brandLogo: state?.brandLogoPath || null,
        playableBanner: state?.brandBannerPath || null,
        type: 'brand',
        id : state?._id || null

    });

    const [industries, setIndustries] = useState([]);
    const [previews, setPreviews] = useState({
        logo: ApiUrls.imediaroot+state?.brandLogoPath || null,
        banner: ApiUrls.imediaroot+state?.brandBannerPath || null
    });

    console.log("previews",previews);
    
     const [iconFile, setIconFile] = useState(null)
            const [bannerFile, setBannerFile] = useState(null)
    

    const handleDropdownClick = () => {
        if (industries.length === 0) {
            PostAPI(`/listAll`, { type: "industries" }, (res) => {
                if (res && res.success) {
                    console.log("Industries fetched on click",res.data);
                    setIndustries(res.data || []);
                } else {
                    console.error("Failed to fetch industries:", res);
                }
            });
        }
    };

    // useEffect(() => {
    //     // Fetch industries for the dropdown
    //     // GetAPI('/cms/industries', (res) => {
    //     //     if (res?.success) setIndustries(res.data);
    //     // });
    //             PostAPI(`/listAll`, {type:"industries"}, (res) => {
    //             // setLoading(false);
    //             if (res && res.success) {
    //                 console.log("PostAPI")
    //                 setIndustries(res.data || []); 
    //             } else {
    //                 console.error("Failed to fetch industries:", res);
    //             }
    //         });
    // }, []);

   

    const removeFile = (field) => {
        setPreviews({ ...previews, [field]: null });
        setFormData({ ...formData, [field === 'logo' ? 'brandLogo' : 'playableBanner']: null });
    };


        const handleUpload = (e, field) => {
            const file = e.target.files[0];
            if (file) {
                setPreviews({ ...previews, [field]: URL.createObjectURL(file) });
                if (field === 'logo') {
                    setIconFile(file);
                } else if (field === 'banner') {
                    setBannerFile(file);
                }
            }
        };

    const handleSave = () => {
        const url = isEdit ? `/edit` : `/create`;

        PostAPI(url, formData, (res) => {
            console.log("resssssssss",res);
            
            if (res?.success) {
                const recordId = formData.id || res?.data?._id || res?.data?.id;

                if (recordId && (iconFile || bannerFile)) {
                    const uploadData = new FormData();

                    if (iconFile) uploadData.append('logo', iconFile); // Using 'logo' as specified in your updated snippet
                    if (bannerFile) uploadData.append('banner', bannerFile);

                    uploadData.append('id', recordId);
                    uploadData.append('type', 'brand'); // Force type to brand since this handles brands


                    FileUploadAPI(uploadData, (uploadRes) => {
                        console.log("Upload Success:", uploadRes);
                        alert(isEdit ? "Brand updated successfully with assets!" : "Brand created successfully with assets!");
                        navigate('/brand');
                    });
                } else {
                    alert(isEdit ? "Brand updated successfully!" : "Brand created successfully!");
                    navigate('/brand');
                }
            } else {
                alert("Failed to save brand: " + (res?.message || "Unknown error"));
            }
        });
    };
    const newhandleSave = () => {
        const apiUrl = ApiUrls.StaticPlayableApiUrl;
        let input_map = {}
        input_map.url = apiUrl
        input_map.body = formData
        FormAPI.Post_fetch(input_map)
    }



    return (
        <div className="brand-form-container">            
            <div className="preview-sidebar">
                <div className="mobile-mockup">
                    <div className="screen">
                        {previews.banner ? (
                            <img src={previews.banner} alt="Banner" className="banner-preview" />
                        ) : (
                            <div className="placeholder-banner">Banner Preview</div>
                        )}
                        <div className="logo-overlay">
                            {previews.logo ? (
                                <img src={previews.logo} alt="Logo" className="logo-preview" />
                            ) : (
                                <div className="placeholder-logo">Logo</div>
                            )}
                        </div>
                        <div className="content-preview">
                            <h4>{formData.name || "Brand Name"}</h4>
                            <p>{formData.playableDescription || "Playable description will appear here..."}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="form-main">
                <h2>{isEdit ? 'Edit Brand' : 'Create Brand'}</h2>

                <label>Industry</label>
                <select value={formData.industryId} onClick={handleDropdownClick} onChange={e => setFormData({ ...formData, industryId: e.target.value })}>
                    <option value="">Select Industry</option>
                    {industries.map(ind => <option key={ind._id} value={ind._id}>{ind.name}</option>)}
                </select>

                <label htmlFor='brand-name'>Brand Name</label>
                <input type="text" id='brand-name' value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="e.g. CocaCola" />

                <label htmlFor='brand-description'>Description</label>
                <textarea id='brand-description' value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} placeholder="Brand general description" />

                <div className="file-upload-row">
                    <div className="upload-box">
                        <label>Brand Logo (.webp)</label>
                        {!previews.logo ? (
                            <input type="file" accept=".webp" onChange={e => handleUpload(e, 'logo')} />
                        ) : (
                            <div className="file-attached">
                                <span>Logo Attached</span>
                                <button onClick={() => removeFile('logo')}>Remove</button>
                            </div>
                        )}
                    </div>

                    <div className="upload-box">
                        <label>Playable Banner (.webp)</label>
                        {!previews.banner ? (
                            <input type="file" accept=".webp" onChange={e => handleUpload(e, 'banner')} />
                        ) : (
                            <div className="file-attached">
                                <span>Banner Attached</span>
                                <button onClick={() => removeFile('banner')}>Remove</button>
                            </div>
                        )}
                    </div>
                </div>

                <label htmlFor='playable-description'>Playable Description</label>
                <input type="text" id="playable-description" value={formData.brandPlayableDescription} onChange={e => setFormData({ ...formData, brandPlayableDescription: e.target.value })} placeholder="Short description for playable" />

                <div className="form-actions">
                    <button className="cancel-btn" onClick={() => navigate('/brand')}>Cancel</button>
                    <button className="save-btn" onClick={handleSave}>Save Brand</button>

                </div>
            </div>
        </div>
    );
}

export default BrandForm;